import React, {Dispatch, SetStateAction, useContext, useState} from "react";
import {TEmailTemplate} from "../../../interfaces/email";
import {addErrorAlert, addSuccessAlert, gridAction} from "../../../patterns/list/listUtils";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {GridRowParams} from "@mui/x-data-grid";
import {useTranslation} from "react-i18next";
import RestoreDialog from "../../../patterns/dialog/restoreDialog";
import {restoreEmailTemplate} from "../../../services/AdminService";
import {errorManager, manageStringError} from "../../../common/methods/ApiService";
import {StoreContext} from "../../../common/struct/store";
import {AppContext} from "../../../App";
import {TAlert} from "../../../patterns/list/listSnackbar";
import {useNavigate} from "react-router-dom"

export default function ListArchivedEmailTemplatesActions(params: GridRowParams, setReload: (reload: boolean) => void, setAlerts: Dispatch<SetStateAction<TAlert[]>>, setReloadParent: (reload: boolean) => void): JSX.Element[] {
  const {t} = useTranslation();
  const STORE = useContext<StoreContext>(AppContext);
  const navigate = useNavigate();

  const [template, setTemplate] = useState<TEmailTemplate | null>(null);
  const [openRestoreDialog, setOpenRestoreDialog] = useState(false);
  const closeRestoreDialog = (): void => setOpenRestoreDialog(false);

  const restore = (): void => {
    if (template == null) return;

    restoreEmailTemplate(template.id)
      .then(() => {
        setReload(true);
        setReloadParent(true);
        addSuccessAlert(t("email_templates.archived.actions.restore_success", {name: template.name}), setAlerts);
      })
      .catch(error => manageStringError(errorManager(error, t, STORE, navigate), error => addErrorAlert(error, setAlerts), t))
      .finally(() => closeRestoreDialog())
  }

  const openRestore = (template: TEmailTemplate): void => {
    setTemplate(template);
    setOpenRestoreDialog(true);
  }

  const dialogs = [
    <RestoreDialog key="restore-template" open={openRestoreDialog} close={closeRestoreDialog}
      title={t("email_templates.archived.actions.restore_title", {name: template?.name})}
      info={t("email_templates.archived.actions.restore_content")}
      restoreElement={restore} />
  ]

  return [
    gridAction(params, "restore", t("email_templates.archived.actions.restore"), AutorenewIcon, openRestore),
    ...(template ? dialogs : [])
  ]
}
